import React from 'react';
import { CaseLink } from './CaseLink';
import { StatuteLink } from './StatuteLink';

export const useCaseLinkTransformer = (tabbable?: boolean) => {
  return React.useCallback(
    (element: HTMLElement, children: React.ReactNode) => {
      if (element.tagName.toLowerCase() === 'a' && element.dataset.caseUrlId) {
        const dataProps: any = {};

        Object.keys({ ...element.dataset }).map((key: string) => {
          switch (key) {
            case 'caseUrlId':
              dataProps['data-case-url-id'] = element.dataset.caseUrlId;
              break;
            case 'statuteSection':
              dataProps['data-statute-section'] =
                element.dataset.statuteSection;
              break;
          }
        });

        return (
          <CaseLink
            judicataId={element.dataset.caseUrlId}
            {...dataProps}
            tabbable={tabbable}
          >
            {children}
          </CaseLink>
        );
      }
      return null;
    },
    [tabbable],
  );
};

export const useTabbableCaseLinkTransformer = () => {
  return useCaseLinkTransformer(true);
};

export const useStatuteLinkTransformer = (tabbable?: boolean) => {
  return React.useCallback(
    (element: HTMLElement, children: React.ReactNode) => {
      if (element.tagName.toLowerCase() === 'a' && element.dataset.statuteJdx) {
        const dataProps: any = {};

        Object.keys({ ...element.dataset }).map((key: string) => {
          switch (key) {
            case 'statuteJdx':
              dataProps['data-statute-jdx'] = element.dataset.statuteJdx;
              break;
            case 'statuteCode':
              dataProps['data-statute-code'] = element.dataset.statuteCode;
              break;
            case 'statuteArticle':
              dataProps['data-statute-article'] =
                element.dataset.statuteArticle;
              break;
            case 'statuteSection':
              dataProps['data-statute-section'] =
                element.dataset.statuteSection;
              break;
          }
        });

        return (
          <StatuteLink
            jurisdictionId={element.dataset.statuteJdx}
            codeJudicataId={element.dataset.statuteCode}
            statuteArticle={element.dataset.statuteArticle}
            sectionBegin={element.dataset.statuteSection}
            tabbable={tabbable}
            {...dataProps}
          >
            {children}
          </StatuteLink>
        );
      }
      return null;
    },
    [tabbable],
  );
};

export const useTabbableStatuteLinkTransformer = () => {
  return useStatuteLinkTransformer(true);
};
